import React, {useCallback, useEffect, useState} from 'react';
import Button from './common/components/Button';
import FooterImage from '../assests/img/login-footer.svg?react';
import MicrosoftIcon from '../assests/img/microsoft-icon.png?url';
import {useMsal} from '@azure/msal-react';
import {loginRequest} from '../authConfig';
import {toast} from 'react-toastify';
import '../assests/css/login.scss';
import HomeLogo from './common/components/HomeLogo';

export default function Login() {

  const {instance} = useMsal();

  const [loading, setLoading]=useState(false);

  const loginRedirect = useCallback(async ()=> {
    setLoading(true);
    await instance.loginPopup(loginRequest).catch((e) => {
      toast(e);
      setLoading(false);
    });
    setLoading(false);
  }, [
    instance,
  ]);

  useEffect(()=> {
    loginRedirect();
  }, []);

  return (
    <div className="login-container">
      <div className="login-section">
        <h2 className="login-page-title">HUB Marketing Exchange</h2>
        <section className="login-card-container">
            <div className="login-card-contents">
              <HomeLogo/>
              <h4 className="login-text">Please sign in to continue</h4>
              <Button onClick={loginRedirect} buttonText="Sign in with Microsoft" buttonIconUrl={MicrosoftIcon}
                loading={loading}/>
            </div>
        </section>
      </div>
      <footer className="login-footer">
          <FooterImage/>
      </footer>
    </div>
  );
}